import { AppBranding } from '@percept/types'


// App-level BroadcastChannel
export const APP_BROADCAST_CHANNEL_NAME = `percept-app-${process.env.APP}`

export const appBroadcastChannel = new BroadcastChannel(APP_BROADCAST_CHANNEL_NAME)

export const APP_BROADCAST_ACTION__SIGN_IN = 'SIGN_IN'
export const APP_BROADCAST_ACTION__SIGN_OUT = 'SIGN_OUT'

export const broadcastAppAction = <T>(action: string, data?: T): void => (
  appBroadcastChannel.postMessage({ action, data })
)

export const broadcastSignIn = (): void => broadcastAppAction(APP_BROADCAST_ACTION__SIGN_IN)
export const broadcastSignOut = (): void => broadcastAppAction(APP_BROADCAST_ACTION__SIGN_OUT)


// Branding
const { BRANDING } = process.env

export const WHITELABEL_BRANDS: AppBranding[] = [
  'APERTO',
]

export const isWhitelabelDefaultBranding = (
  WHITELABEL_BRANDS.includes(BRANDING as AppBranding)
)

const brandingPlatformMap: Partial<Record<AppBranding, string>> = {
  PERCEPT: 'Percept',
  VODAFONE: 'Vodafone Media Wizard',
  APERTO: 'Aperto',
}

export const getBrandingPlatformName = (branding: AppBranding): string => {
  if( BRANDING !== 'PERCEPT' ){
    return brandingPlatformMap[BRANDING as AppBranding] || 'Percept'
  }
  if( !branding ) return 'Percept'
  return brandingPlatformMap[branding] || 'Percept'
}
